/* eslint-disable */
import particles from './vue-particles.vue'

const VueParticles = {

    install:function(Vue, options) {
        Vue.component('vue-particles', particles)
    }

}

export default VueParticles
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/views/components/vue-particles/index.js